import { GALLERY_LANDSCAPE, GALLERY_LANDSCAPE_TWO_COLUMN } from '@tilelist/domain/composition/BracketLayout.ts';
import type { TileListPageLayout } from '@tilelist/domain/composition/TileListPage.ts';
import { EXPERIMENT_ONEX_IDS, type ExperimentOnexId } from '@tilelist/domain/experiments/Experiments.ts';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';
import { isBrandTileExperimentEligible } from '@tilelist/domain/feature-visibility/BrandTile.ts';
import { isInCleanTileV3Segment } from '@tilelist/domain/feature-visibility/TopInfoVisibility.ts';

type ExperimentDefinition = {
    /*                                                                                            */
    experimentId: ExperimentOnexId;
    /*                                                                                                                                  */
    experimentShouldBeTracked: boolean;
};

/**
 *
 *
 *
 */
type GenericExperimentDefinition = {
    experimentId: string;
    experimentShouldBeTracked: boolean;
};

/*                                                                                                                                                           */
const EXP_OVERRIDE_ID = 'noExperiment';

function getExperimentDefinitions(pageView: TileListPageLayout, onex: OnEx): ExperimentDefinition[] {
    const searchContext = pageView.context.searchContext;
    const layout = pageView.context.layout;
    const isLandscapeSegment =
        layout.imageAspectRatio === GALLERY_LANDSCAPE.imageAspectRatio ||
        layout.imageAspectRatio === GALLERY_LANDSCAPE_TWO_COLUMN.imageAspectRatio;

    return [
        {
            /*                                                                  */
            experimentId: EXPERIMENT_ONEX_IDS.CLEAN_TILE_V3,
            experimentShouldBeTracked: isInCleanTileV3Segment(searchContext, onex),
        },
        {
            /*                                                               */
            experimentId: EXPERIMENT_ONEX_IDS.TEASER_VARIATION_BOOST,
            experimentShouldBeTracked: pageView.teaserVariationBoostTracked ?? false,
        },
        {
            /*                                                               */
            /*                                                                */
            /*                                           */
            /*                                                              */
            /*                                                         */
            /*                                            */
            experimentId: EXPERIMENT_ONEX_IDS.GALLERY_LANDSCAPE_TWO_COLUMN,
            experimentShouldBeTracked: isLandscapeSegment && onex.isExperimentActive('GALLERY_LANDSCAPE_TWO_COLUMN'),
        },
        {
            experimentId: EXPERIMENT_ONEX_IDS.BRAND_TILE,
            experimentShouldBeTracked:
                isBrandTileExperimentEligible(searchContext) && onex.isExperimentActive('BRAND_TILE'),
        },
    ];
}

/**
 *
 *
 *
 *
 */
export function aggregateExperimentTracking(definitions: GenericExperimentDefinition[]): {
    experimentIds: string[];
} {
    const trackedExperimentIds = definitions.filter((d) => d.experimentShouldBeTracked).map((d) => d.experimentId);

    return {
        experimentIds: trackedExperimentIds.length > 0 ? trackedExperimentIds : [EXP_OVERRIDE_ID],
    };
}

export function collectFeatureTracking(
    pageView: TileListPageLayout,
    onex: OnEx,
): {
    experimentIds: string[];
} {
    return aggregateExperimentTracking(getExperimentDefinitions(pageView, onex));
}
